export default __webpack_public_path__ + "static/media/thumb_6.e1ec2c76.webp";